import { AssemblyType } from '../../../enums/AssemblyType';

// campos obrigatórios do cadastro (os opcionais são editados depois)
export class CreateLocationInput {
  shopifyId: number;
  name: string;
  isOmnichannel: boolean;
  manageOrderInSislog: boolean;
  manageOrderInSislogSinceDate?: string | null;
  communicateClientDeadline: boolean;
  communicateClientDeadlineForOrderAfterDate?: string | null;
  assemblyType: AssemblyType;
}
